import { render, staticRenderFns } from "./CatalogMedicineList.vue?vue&type=template&id=b595cbb6&scoped=true"
import script from "./CatalogMedicineList.vue?vue&type=script&lang=js"
export * from "./CatalogMedicineList.vue?vue&type=script&lang=js"
import style0 from "./CatalogMedicineList.vue?vue&type=style&index=0&id=b595cbb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b595cbb6",
  null
  
)

export default component.exports